import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import axios from 'axios';

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const Revenue = () => {
    const [revenueData, setRevenueData] = useState([]);
    const [timeRange, setTimeRange] = useState('weekly');
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [averageRevenue, setAverageRevenue] = useState(0);

    useEffect(() => {
        fetchRevenueData();
    }, [timeRange]);

    const fetchRevenueData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/revenue?timeRange=${timeRange}`);
            if (Array.isArray(response.data.data)) {
                setRevenueData(response.data.data);
                calculateTotalRevenue(response.data.data);
            } else {
                console.error('Unexpected data format:', response.data);
            }
        } catch (error) {
            console.error('Error fetching revenue data:', error);
        }
    };

    const calculateTotalRevenue = (data) => {
        const total = data.reduce((sum, item) => sum + item.totalRevenue, 0);
        setTotalRevenue(total);
        setAverageRevenue(total / data.length || 0);
    };

    const chartData = {
        labels: revenueData.map((data) => new Date(data._id).toLocaleDateString()),
        datasets: [
            {
                label: 'Revenue',
                data: revenueData.map((data) => data.totalRevenue),
                fill: false,
                backgroundColor: '#ff5e15',
                borderColor: '#011855',
            },
        ],
    };

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    };

    return (
        <div style={{ padding: '1rem' }}>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Revenue Dashboard</h1>

            <div
                style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1rem' }}
            >
                <div style={{ border: '1px solid #ccc', borderRadius: '0.5rem', padding: '1rem' }}>
                    <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Total Revenue</h2>
                    <p style={{ fontSize: '1.5rem', fontWeight: 'semibold' }}>{formatCurrency(totalRevenue)}</p>
                </div>

                <div style={{ border: '1px solid #ccc', borderRadius: '0.5rem', padding: '1rem' }}>
                    <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Average Revenue</h2>
                    <p style={{ fontSize: '1.5rem', fontWeight: 'semibold' }}>{formatCurrency(averageRevenue)}</p>
                </div>

                <div style={{ border: '1px solid #ccc', borderRadius: '0.5rem', padding: '1rem' }}>
                    <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Time Range</h2>
                    <select
                        value={timeRange}
                        onChange={(e) => setTimeRange(e.target.value)}
                        style={{ width: '100%', padding: '0.5rem', marginTop: '0.5rem' }}
                    >
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                    </select>
                </div>
            </div>

            <div style={{ border: '1px solid #ccc', borderRadius: '0.5rem', padding: '1rem' }}>
                <h2 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '1rem' }}>Revenue Over Time</h2>
                <Line
                    data={chartData}
                    options={{
                        responsive: true,
                        scales: {
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    callback: (value) => formatCurrency(value),
                                },
                            },
                        },
                        plugins: {
                            tooltip: {
                                callbacks: {
                                    label: (context) => `Revenue: ${formatCurrency(context.parsed.y)}`,
                                },
                            },
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default Revenue;
